document.addEventListener('DOMContentLoaded', function () {
  let currentSidebar = null;
  

  function createSidebarHTML(ingredientData) {
    return `
      <div class="m-cart-drawer__inner border-size-drawer m:h-full m-gradient">
        <button class="m-cart-drawer__close m-size-drawer__close" aria-label="Close">
          <svg class="m-svg-icon--large" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
            <path d="M16.6259 15.8343L11.4104 10.6188M11.4104 10.6188L6.19482 5.40327M11.4104 10.6188L16.6259 5.40327M11.4104 10.6188L6.19482 15.8344" stroke="currentColor" stroke-width="1.25939" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        
         <div class="m:flex m:flex-col m:h-full">
          <div class="m-cart-drawer__header">
            <h3 class="m-size-drawer__title"></h3>
          </div>

          <div class="m-cart-drawer__content">
            <div class="size-guide-tf">
              <div class="ingredient-detail-content" style="padding: 20px;">
                
                ${ingredientData.nombre ? `
                  <h1 class="title-sidebar">
                    ${ingredientData.nombre} 
                  </h2>
                ` : ''}

                ${ingredientData.beneficio_principal ? `
                  <div class="subtitle-sidebar">
                    <p>${ingredientData.beneficio_principal}</p>
                  </div>
                ` : ''}


                ${ingredientData.imagen ? `
                  <div class="ingredient-image">
                    <img src="${ingredientData.imagen}" 
                         alt="${ingredientData.nombre || 'Ingrediente'}" 
                         loading="lazy"
                         style="width: 100%; height: auto;">
                  </div>
                ` : ''}
                
                ${ingredientData.descripcion_corta ? `
                  <div class="description-sidebar">
                    <p>${ingredientData.descripcion_corta}</p>
                  </div>
                ` : ''}


                ${(ingredientData.dosis || ingredientData.comparacion) ? `
                  <div class="recomendada-comparacion">
                    ${ingredientData.dosis ? `
                      <div class="recom-acion recomendada-sidebar">
                        <h6>Dosis recomendada</h6>
                        <p>${ingredientData.dosis}</p>
                      </div>
                    ` : ''}

                    ${ingredientData.comparacion ? `
                      <div class="recom-acion comparacion-sidebar">
                        <h6>Comparación</h6>
                        <p>${ingredientData.comparacion}</p>
                      </div>
                    ` : ''}
                  </div>
                ` : ''}

                
                ${ingredientData.beneficios_richtext ? `
                  <div class="beneficios-sidebar">
                    <h6>Beneficios</h6>
                    <p>${ingredientData.beneficios_richtext}</p>
                  </div>
                ` : ''}

                
                ${ingredientData.lista_beneficios && ingredientData.lista_beneficios.length > 0 ? `
                  <div class="ingredient-benefits">
                    <ul class="benefits-list" style="list-style: none; padding-left: 0;">
                      ${ingredientData.lista_beneficios.map(beneficio => `
                        <li>
                          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="20" viewBox="0 0 13 20" fill="none">
                            <path d="M2.72803 0.789429C3.44915 0.74131 4.34209 0.796455 5.23096 0.875366C6.62697 0.996628 7.9651 1.34178 9.15674 2.10974C10.7399 3.13185 11.7061 4.57151 12.0513 6.42517C12.3829 8.20563 12.3658 10.0053 12.2983 11.8011C12.254 12.9926 12.1695 14.1904 11.8687 15.3588C11.5408 16.631 10.9178 17.684 9.73584 18.348C9.22099 18.6387 8.67285 18.8423 8.104 18.9828C7.12643 19.2253 6.13494 19.3374 5.13037 19.1449C4.78166 19.0774 4.55217 18.8078 4.54053 18.4769C4.52703 18.0939 4.67819 17.8803 5.0542 17.7533C5.21606 17.6995 5.37787 17.6648 5.55322 17.6879C6.36499 17.7918 7.14606 17.6487 7.90576 17.3793C9.30549 16.8807 10.0571 15.8589 10.2866 14.4154C10.4409 13.4414 10.505 12.4634 10.4761 11.4779C10.4645 11.1026 10.4276 11.064 10.0767 11.139C9.0625 11.3584 8.0349 11.4466 7.00146 11.3773C5.71347 11.2907 4.48131 11.0004 3.37646 10.2787C2.14436 9.47413 1.39217 8.33077 0.942871 6.96228C0.725025 6.29835 0.657588 5.61693 0.645996 4.92029C0.628643 3.93865 0.57196 2.95655 0.585449 1.97107C0.589304 1.6632 0.630584 1.35904 0.647949 1.0531C0.659519 0.852913 0.744134 0.785551 0.933105 0.787476C1.47294 0.793248 2.01278 0.789429 2.72803 0.789429ZM7.45459 5.26892C7.32536 5.28625 7.15945 5.27661 7.14209 5.47107C7.12684 5.64025 7.24058 5.71508 7.37549 5.77087C7.41779 5.79007 7.4582 5.81309 7.50049 5.82849C8.20435 6.08837 8.7542 6.52764 9.12451 7.18591C9.19006 7.30331 9.26551 7.44587 9.43701 7.40369C9.5701 7.36903 9.55134 7.24 9.55713 7.06287C9.49346 6.46607 9.16935 5.95184 8.62744 5.56873C8.27642 5.32421 7.88276 5.21502 7.45459 5.26892Z" fill="#C2D18A"/>
                          </svg>
                          ${beneficio.texto || beneficio}
                        </li>
                      `).join('')}
                    </ul>
                  </div>
                ` : ''}

              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  
  function openSidebar(ingredientData) {
    if (currentSidebar) {
      closeSidebar();
      return;
    }
    
    // Crear el contenedor del sidebar
    const sidebarContainer = document.createElement('div');
    sidebarContainer.className = 'm-cart-drawer m-cart-drawer--active';
    
    // Establecer propiedades CSS iniciales
    sidebarContainer.style.setProperty("--m-bg-opacity", "0");
    sidebarContainer.style.setProperty("--translate-x", "100%");
    
    sidebarContainer.innerHTML = createSidebarHTML(ingredientData);
    
    document.body.appendChild(sidebarContainer);
    currentSidebar = sidebarContainer;
    
    // Prevenir scroll en el body
    document.documentElement.classList.add("prevent-scroll");
    
    // Animación de entrada con doble requestAnimationFrame para suavidad
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sidebarContainer.style.setProperty("--m-bg-opacity", "0.5");
        sidebarContainer.style.setProperty("--translate-x", "0");
      });
    });
    
    // Event listeners
    setupEventListeners(sidebarContainer);
  }
  
  function closeSidebar() {
    if (!currentSidebar) return;
    
    // Animación de salida
    currentSidebar.style.setProperty("--m-bg-opacity", "0");
    currentSidebar.style.setProperty("--translate-x", "100%");
    
    setTimeout(() => {
      currentSidebar.classList.remove('m-cart-drawer--active');
      document.documentElement.classList.remove("prevent-scroll");
      
      setTimeout(() => {
        currentSidebar?.remove();
        currentSidebar = null;
      }, 100);
    }, 300);
  }
  
  function setupEventListeners(sidebar) {
    // Botón de cerrar
    const closeButton = sidebar.querySelector('.m-cart-drawer__close');
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeSidebar();
      });
    }
    
    // Click fuera del sidebar
    const handleOutsideClick = (event) => {
      const sidebarContent = sidebar.querySelector('.m-cart-drawer__inner');
      const isOpenButton = event.target.closest('.open-ingredient-detail');
      
      if (sidebarContent && !sidebarContent.contains(event.target) && !isOpenButton) {
        closeSidebar();
      }
    };
    
    setTimeout(() => {
      sidebar.addEventListener('click', handleOutsideClick);
    }, 100);
    
    // Tecla ESC
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        closeSidebar();
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);
  }
  
  // Manejar clicks en los botones de ingredientes
  function handleIngredientClick(event) {
    const button = event.target.closest('.open-ingredient-detail');
    if (!button) return;
    
    event.preventDefault();
    event.stopPropagation();
    
    // Obtener datos del ingrediente desde los data attributes
    const allBenefits = extractListaBeneficios(button);
    const { beneficioPrincipal, listaBeneficios } = separateBenefits(allBenefits);
    
    const ingredientData = {
      nombre: button.dataset.ingredientName || '',
      imagen: button.dataset.ingredientImage || '',
      descripcion_corta: extractTextFromRichText(button.dataset.ingredientDescripcionCorta) || '',
      dosis: extractTextFromRichText(button.dataset.ingredientDosis) || '',
      comparacion: extractTextFromRichText(button.dataset.ingredientComparacion) || '',
      beneficios_richtext: extractTextFromRichText(button.dataset.ingredientBeneficiosRichtext) || '',
      beneficio_principal: beneficioPrincipal,
      lista_beneficios: listaBeneficios
    };
    
    console.log('🎯 Opening ingredient:', ingredientData);
    openSidebar(ingredientData);
  }
  
  // Separar el primer beneficio como principal y el resto como lista
  function separateBenefits(allBenefits) {
    if (!allBenefits || allBenefits.length === 0) {
      return { beneficioPrincipal: '', listaBeneficios: [] };
    }
    
    // El primer beneficio es el principal
    const beneficioPrincipal = allBenefits[0].texto || allBenefits[0];
    
    // Los beneficios restantes (desde el índice 1 en adelante)
    const listaBeneficios = allBenefits.slice(1);
    
    return { beneficioPrincipal, listaBeneficios };
  }
  
  // Extraer texto simple de rich text (JSON structure)
  function extractTextFromRichText(richTextData) {
    if (!richTextData) return '';
    
    try {
      const parsed = JSON.parse(richTextData);
      // Extraer texto de la estructura rich text
      if (parsed.children && Array.isArray(parsed.children)) {
        return extractTextFromChildren(parsed.children);
      }
      return richTextData;
    } catch (e) {
      // Si no es JSON válido, devolver el texto original
      return richTextData;
    }
  }
  
  // Función recursiva para extraer texto de children
  function extractTextFromChildren(children) {
    let text = '';
    
    children.forEach(child => {
      if (child.value) {
        text += child.value;
      } else if (child.children && Array.isArray(child.children)) {
        text += extractTextFromChildren(child.children);
      }
    });
    
    return text;
  }
  
  // Extraer lista de beneficios (con iconos) desde el data attribute
  function extractListaBeneficios(button) {
    const beneficiosData = button.dataset.ingredientListaBeneficios;
    if (beneficiosData) {
      try {
        const beneficios = JSON.parse(beneficiosData);
        return Array.isArray(beneficios) ? beneficios : [];
      } catch (e) {
        console.error('Error parsing beneficios:', e);
        return [];
      }
    }
    return [];
  }
  
  // Event delegation para los botones
  document.addEventListener('click', handleIngredientClick);
  
  // API pública
  window.openIngredientModal = openSidebar;
  window.closeIngredientModal = closeSidebar;
});